import { iCeilingHeight } from './CeilingHeightDataTypes';
import { CEILING_HEIGHT } from '../draftKeys';

const defaultState: iCeilingHeight = {
  [CEILING_HEIGHT]: 0,
};

export default defaultState;
